<template>

    <div>
        
        <nav class="navbar fixed-top">

            <div class="navbar-brand">
                <router-link to="/" tag="a" active-class="is-active" exact class="navbar-item">
                    <h1 class='title'>
                        Denn
                    </h1>
                </router-link>

                <!-- is-hidden-desktop keeps this only visible on mobile and as its in navbar-brand, outside the burger menu -->
                <b-tooltip label="Flagged Only" position="is-bottom">
                    <b-field class="navbar-item is-hidden-desktop">
                        <b-switch v-model="published" @input="PublishedToggle">
                            <b-icon icon="flag" size="is-small" type="is-primary"></b-icon>
                        </b-switch>
                    </b-field>
                </b-tooltip>
                <div class="navbar-item is-hidden-desktop">
                    <reviewable-upload></reviewable-upload>
                </div>
                
                <!-- toggle shownav when burger is pressed -->
                <a class="navbar-burger burger" @click="showNav=!showNav" v-bind:class="{ 'is-active' : showNav }">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>

            </div>

            <!-- is-active means only viewable on mobile -->
            <div class="navbar-menu" v-bind:class="{ 'is-active' : showNav }"> 
                <div class="navbar-start">
                    <!-- similar to upload form could be a component instead -->
                    <b-field id="projects_autocomplete" class="navbar-item">
                        <b-autocomplete
                            v-model="project_autocomplete_name"
                            :data="ProjectsFiltered"
                            :open-on-focus=true
                            placeholder="Projects..."
                            icon="magnify"
                            @select=NavToSelectedProject($event)
                        >
                            <template slot="empty">
                                No results found
                            </template>

                        </b-autocomplete>
                    </b-field>

                    <!--
                    use router-link to set the active class (based on the url)
                    exact stops /projects from picking up the / + projects
                    -->
                    <router-link to="/" tag="a" active-class="is-active" exact class="navbar-item">
                        Home
                    </router-link>
                    <router-link to="/projects" tag="a" active-class="is-active" class="navbar-item">
                        Projects
                    </router-link>
                    <router-link to="/shares" tag="a" active-class="is-active" class="navbar-item">
                        Shares
                    </router-link>
                    <router-link to="/scenes" tag="a" active-class="is-active" class="navbar-item">
                        Scenes
                    </router-link>
                    <!-- is_user_admin comes from mixin -->
                    <a v-if="is_user_admin" href="/admin/" active-class="is-active" class="navbar-item">
                        Admin
                    </a>

                    <b-field id="tags_autocomplete" class="navbar-item">
                        <b-autocomplete
                            v-model="tags_autocomplete_name"
                            :data="TagsFiltered"
                            :open-on-focus=true
                            placeholder="Tags..."
                            icon="magnify"
                            @select=NavToSelectedTag($event)
                        >
                            <template slot="empty">
                                No results found
                            </template>
                        </b-autocomplete>
                    </b-field>

                    <b-field id="tags_autocomplete" class="navbar-item">
                        <b-input placeholder="Search..."
                            type="search"
                            icon="magnify"
                            icon-clickable
                            @icon-click="UpdateSearch"
                            @keyup.native.enter="UpdateSearch"
                            v-model=query_search>
                        </b-input>
                    </b-field>

                </div>

                <div class="navbar-end">
                    
                    <b-tooltip label="Flagged Only" position="is-bottom">
                        <b-field class="navbar-item is-hidden-mobile">
                            <b-switch v-model="published" @input="PublishedToggle">
                                <b-icon icon="flag" size="is-small" type="is-primary"></b-icon>
                            </b-switch>
                        </b-field>
                    </b-tooltip>

                    <b-tooltip label="User Settings" position="is-bottom">
                        <router-link to="/usersettings" tag="a" active-class="is-active" class="navbar-item">
                            <b-icon icon="account-circle" size="is-medium" type="is-primary"></b-icon>
                        </router-link>
                    </b-tooltip>

                    <b-tooltip label="Log out" position="is-bottom">
                        <a  @click="LogOut()" class="navbar-item">
                            <b-icon icon="logout" size="is-medium" type="is-primary"></b-icon>
                        </a>
                    </b-tooltip>

                    <div class="navbar-item is-hidden-mobile">
                        <reviewable-upload></reviewable-upload>
                    </div>

                </div>
            </div>
        </nav>

        <!-- hidden until in use -->
        <share-pick-panel></share-pick-panel>

    </div>
</template>


<script>
    // import get projects mixin
    import { GetProjectNames } from '../mixins/Projects'
    import { GetTags } from '../mixins/Tags'
    import { ReviewableQuerys } from '../mixins/querys'

    // for is_user_admin
    import { GetUserAdmin } from '../mixins/users'

    // import to use component
    import SharePickPanel from './SharePickPanel.vue'
    import Auth from './Auth.vue'

    import { eventBusPublished } from '../main';

    export default {
        mixins: [GetProjectNames, GetTags, GetUserAdmin, ReviewableQuerys],
        data() {
            return {
                showNav: false,
                LoggedIn: false,

                // for autocomplete
                project_autocomplete_name: '',
                project_autocomplete_selected: null,
                tags_autocomplete_name: '',
                tags_autocomplete_selected: null,

                // published view switch init (updated via created method)
                published: eventBusPublished.only_published,
            }
        },
        components: {
            'share-pick-panel': SharePickPanel,
            auth: Auth,
        },
        computed: {
            ProjectsFiltered() {
                // for projects autocomplete
                return this.project_names.filter((option) => {
                    return option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.project_autocomplete_name.toLowerCase()) >= 0
                })
            },
            TagsFiltered() {
                // for tags autocomplete
                return this.tagnames.filter((option) => {
                    return option
                        .toString()
                        .toLowerCase()
                        .indexOf(this.tags_autocomplete_name.toLowerCase()) >= 0
                })
            },
            userid() {
                // den_user_slack_username key is the same as the actual user name in admin
                // useful to restrict access etc.
                return localStorage.getItem('den_user_slack_id')
            },
        },
        methods: {
            PublishedToggle(value) {
                eventBusPublished.TogglePublishedOnly()
            },
            LogOut() {
                // remove localstorage
                localStorage.removeItem('den_vueauth_token')
                
                // also delete old ones
                localStorage.removeItem('vue-authenticate.vueauth_token')
                localStorage.removeItem('vue-authenticate.null_state')

                localStorage.removeItem('den_loggedin')
                localStorage.removeItem('den_user')
                localStorage.removeItem('den_user_email')
                localStorage.removeItem('den_user_slack_id')
                localStorage.removeItem('den_user_slack_username')

                // refreshes window properly instead of using the router
                window.location = "/"
            },
            NavToSelectedProject(value) {
                // null is value before one is properly selected
                if (value == null) {
                    return
                }
                // set data as selected (the value)
                this.project_autocomplete_selected = value

                // push adds to list in browser history
                this.$router.push({path: '/project/' + this.project_autocomplete_selected})
            },
            NavToSelectedTag(value) {
                // null is value before one is properly selected
                if (value == null) {
                    return
                }
                // set data as selected (the value)
                this.tags_autocomplete_selected = value
                
                // append router query
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        ['tags__name']: value
                    }
                })
            },
        },
        mounted() {
            eventBusPublished.$on('publish_toggled', (data) => {
                this.published = data
            })
        },
    }

</script>


<style>
    .navbar-burger:hover {
        color: inherit;
    }
    #projects_autocomplete, #tags_autocomplete {
        margin-bottom: inherit;
    }
</style>
